<template>
  <form v-else @submit.prevent="editarProducto">
    <vuestic-widget header-text="Edicion de Producto">
      <DescripcionProducto/>
    </vuestic-widget>
    <vuestic-widget header-text="Detalle Producto Para Web" v-if="isWeb()">
      <DetalleWeb />
    </vuestic-widget>
    <vuestic-widget header-text="Detalle">
      <DetalleProducto/>
    </vuestic-widget>
    <vuestic-widget header-text="Vehiculos Compatibles">
      <VehiculosCompatible />
      <hr>
      <files-drag-n-drop/>
      <br><br>
      <button class="btn btn-info btn-micro" type="submit">Editar Producto</button>
    </vuestic-widget>
  </form>
</template>

<script>
  import VuesticWidget from "../../../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import DescripcionProducto from "../descripcionProducto/DescripcionProducto";
  import DetalleProducto from "../detalleProducto/DetalleProducto";
  import VehiculosCompatible from "../vehiculoCompatible/VehiculosCompatible";
  import FilesDragNDrop from "../../filesDragNDrop";
  import DetalleWeb from "../descripcionWeb/DetalleWeb";
  import mixinProducto from "../mixins/mixinProducto";

  export default {
    name: "EdicionFormulario",
    components: {DetalleWeb, FilesDragNDrop, VehiculosCompatible, DetalleProducto, DescripcionProducto, VuesticWidget},
    mixins: [mixinProducto],
    methods: {
      editarProducto() {
        this.$store.dispatch("producto/crearProducto", {method: "PUT"})
          .then(response => {
            if (response.status === 201) this.successResponse("Producto Editado Correctamente!!")
            else this.errorResponse()
          }).catch(error => {
          console.error(error, "failed to create producto")
          this.$swal("Error!", error, "error")
        })
      },
      successResponse(message) {
        this.$swal("Correcto!", message, "success")
        this.$router.push("listar-producto-miranda")
        this.$store.commit("producto/RESET_STATE")
      },
      errorResponse(response) {
        console.log(response.data)
        this.$swal("Error", "error", "error")
      }
    },

  }
</script>

<style scoped>

</style>
